import { createSlice } from "@reduxjs/toolkit";
/* eslint-disable no-param-reassign */
const initialState = {
  CurrentTab: "dashboard",
  SearchFrom: "Ticket",
  DashboardUserName: "",
  DashboardUserEmail: "",
  DashboardType: "A",
  DashboardTeam: "",
  DashboardStatusDays: "3",
  DashboardStatus: "R",
  DashboardFollowDays: "8000",
  currentTicketNo: "",
  currentPage: 1,
  ClientDetailTab: "ClientDetail",
  currentClientId: "",
  currentEntityId: "",
  currentClientTnsName: "",
  ticketComment: "",
  commentUserEmail: "",
  commentTicketNo: "",
  quickSearch: false,
  quickData: "",
  headerRerender: 0,
  clientPlanDetail: null,
  trainingEvents: null,
  currentClientDetail: null,
  salesPersonList: null,
  currentFacilityId: "",
  clientApiKey: "",
  currentPracticeData: null,
};

export const SharedLayoutDataSlice = createSlice({
  name: "SharedLayoutData",
  initialState,
  reducers: {
    setCurrentTab: (state, action) => {
      state.CurrentTab = action.payload;
    },

    setUserName: (state, action) => {
      state.DashboardUserName = action.payload;
    },

    setUserEmail: (state, action) => {
      state.DashboardUserEmail = action.payload;
    },

    setType: (state, action) => {
      state.DashboardType = action.payload;
    },

    setTeam: (state, action) => {
      state.DashboardTeam = action.payload;
    },

    setStatusDays: (state, action) => {
      state.DashboardStatusDays = action.payload;
    },

    setStatus: (state, action) => {
      state.DashboardStatus = action.payload;
    },

    setFollowDays: (state, action) => {
      state.DashboardFollowDays = action.payload;
    },

    setSearchFrom: (state, action) => {
      state.SearchFrom = action.payload;
    },

    setCurrentTicketNo: (state, action) => {
      state.currentTicketNo = action.payload;
    },

    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },

    setCurrentClientId: (state, action) => {
      state.currentClientId = action.payload;
    },

    setClientDetailTab: (state, action) => {
      state.ClientDetailTab = action.payload;
    },

    setCurrentClientTnsName: (state, action) => {
      state.currentClientTnsName = action.payload;
    },

    setTicketComment: (state, action) => {
      state.ticketComment = action.payload;
    },

    setCommentUserEmail: (state, action) => {
      state.commentUserEmail = action.payload;
    },

    setCommentTicketNo: (state, action) => {
      state.commentTicketNo = action.payload;
    },

    setQuickSearch: (state, action) => {
      state.quickSearch = action.payload;
    },

    setQuickData: (state, action) => {
      state.quickData = action.payload;
    },
    setHeaderRerender: (state, action) => {
      state.headerRerender = action.payload;
    },

    setClientPlanDetail: (state, action) => {
      state.clientPlanDetail = action.payload;
    },

    setTrainingEvents: (state, action) => {
      state.trainingEvents = action.payload;
    },
    setCurrentClientDetail: (state, action) => {
      state.currentClientDetail = action.payload;
    },

    setSalesPersonList: (state, action) => {
      state.salesPersonList = action.payload;
    },

    setCurrentEntityId: (state, action) => {
      state.currentEntityId = action.payload;
    },
    setCurrentFacilityId: (state, action) => {
      state.currentFacilityId = action.payload;
    },
    setClientApiKey: (state, action) => {
      state.clientApiKey = action.payload;
    },
    setCurrentPracticeData: (state, action) => {
      state.currentPracticeData = action.payload;
    },
    clear: () => initialState,
  },
});
export const {
  setCurrentTab,
  setSearchFrom,
  setUserName,
  setUserEmail,
  setType,
  setTeam,
  setStatusDays,
  setClientDetailTab,
  setCurrentTicketNo,
  setCurrentClientId,
  setCurrentPage,
  setStatus,
  setTicketComment,
  setCommentUserEmail,
  setQuickSearch,
  setHeaderRerender,
  setQuickData,
  setClientPlanDetail,
  setTrainingEvents,
  setCurrentClientDetail,
  setCurrentClientTnsName,
  setSalesPersonList,
  setCurrentEntityId,
  setCurrentFacilityId,
  setClientApiKey,
  setCurrentPracticeData,
  setCommentTicketNo,
  clear,
} = SharedLayoutDataSlice.actions;

export default SharedLayoutDataSlice.reducer;
